import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    const isPublicPage = path.startsWith("/pricelist-publik");
    const isAuthCall = (err.config?.url || "").startsWith("/auth/");
    if (err.response?.status === 401 && !isPublicPage && !isAuthCall && !path.startsWith("/login")) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

export const fmtCompact = (n) =>
  "Rp" + new Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 }).format(Number(n) || 0);

export const fmtDate = (d) => {
  if (!d) return "-";
  const dt = new Date(`${d}T00:00:00`);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};

export const today = () => new Date().toISOString().slice(0, 10);

export const apiError = (e, fallback = "Terjadi kesalahan") => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
};

export const fileUrl = (path, w) => `${API}/files/${path}${w ? `?w=${w}` : ""}`;
